import classNames from "classnames";
import { setupLanguageDatePicker } from "../../utils/date";
import { DComponent } from "../DComponent";

setupLanguageDatePicker();

export default class DatePicker extends DComponent {
  constructor({
    parent,
    id,
    label = "",
    isRequired = false,
    inline = false,
    isFullField = false,
    hidePrefix = false,
    hideSuffix = false,
    dateFormat = "dd/mm/yy",
    changeMonth = true,
    changeYear = true,
    yearRange,
    onChange = (value) => { },
    placeholderText,
    placeholderI18n,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("DatePicker", {
        "hide-prefix": hidePrefix,
        "hide-suffix": hideSuffix,
        "hide-label": !label,
        "is-required": isRequired,
        "inline": inline,
        "is-full-field": isFullField,
      }),
      label: label
    });
    this.dateFormat = dateFormat;
    this.changeMonth = changeMonth;
    this.changeYear = changeYear;
    this.yearRange = yearRange;
    this.onChange = onChange;
    this.hidePrefix = hidePrefix;
    this.hideSuffix = hideSuffix;
    this.placeholderText = placeholderText;
    this.placeholderI18n = placeholderI18n;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "DatePicker");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    if (this.placeholderI18n) {
      $("input", this.element).attr("data-i18n", `[placeholder]${this.placeholderI18n}`);
    }
    if (this.placeholderText) {
      $("input", this.element).attr("placeholder", this.placeholderText);
    }
    $.datepicker.setDefaults($.datepicker.regional[$.i18n().locale]);
    this.initPicker();
    $('input', this.element).focus(() => {
      this.element.addClass('focus');
    });

    $('input', this.element).blur(() => {
      this.element.removeClass('focus');
    });
    $("input", this.element).on("input", () => {
      this.checkValue();
    });
    this.checkValue();
  }

  initPicker() {
    $.datepicker.setDefaults($.datepicker.regional[$.i18n().locale]);
    if (this.datePicker) {
      $("input", this.element).datepicker("destroy");
    }
    this.datePicker = $("input", this.element).datepicker({
      dateFormat: this.dateFormat,
      changeMonth: this.changeMonth,
      changeYear: this.changeYear,
      yearRange: this.yearRange,
      constrainInput: false,
      onSelect: () => {
        this.checkValue();
        typeof this.onChange == "function" && this.onChange(this.getValue());
      },
      beforeShow: function (input, inst) {
        $('#ui-datepicker-div').removeClass('DatePickerPopup').addClass('DatePickerPopup');
      }
    }).on('change', (e) => {
      let value = $(e.currentTarget).val();
      try {
        value && $.datepicker.parseDate(this.dateFormat, value);
      } catch (error) {
        this.setValue("");
      }
    });;
  }

  getValue() {
    return $("input", this.element).datepicker("getDate");
  }

  getDateFormat() {
    return $("input", this.element).val();
  }

  setValue(value) {
    $("input", this.element).datepicker("setDate", value);
    this.checkValue();
  }

  checkValue() {
    if ($("input", this.element).val()) {
      if (!this.element.hasClass("has-value")) {
        this.element.addClass("has-value");
      }
      return true;
    } else {
      this.element.removeClass("has-value");
      return false;
    }
  }
}